import FrequenciesAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequencies/frequencies.entity';
import { CommonModule } from '@angular/common';
import { Component, Input, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SubRouteFrequenciesService, WeekdayClientsCount } from '../../sub-routes-frequency/sub-route-frequency.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import SubRouteBusinessPartnersAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/sub-route/sub-route-frequency-bp/sub-route-frequency-bp.entity';
import { SubRouteFrequenciesBPService } from '../../sub-routes-frequency/sub-route-frequencies-bp.service';
import { CdkDragDrop, CdkDropList, DragDropModule, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { cloneDeep } from 'lodash';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICreateManyBPFrecuency, IMoveFrequencyBP } from '../../sub-routes-frequency/interfaces/create-sub-route-bp-frequency';
import { DeleteConfirmationComponent } from 'app/modules/components/business-partners/business-partner/delete-modal/delete-modal.component';
import { MapModalComponent } from 'app/shared/components/map-modal/map-modal.component';
import { MapModalInputData } from 'app/shared/components/map-modal/models/map-modal.interface';
import { MapModalTypeEnum, MonitorDocumentTypeEnum } from 'app/shared/components/map-modal/models/map-modal.enum';
import { ROUTES_PERMISSIONS } from 'app/common/constants/permission';
import { HasPermissionPipe, PermissionService } from 'app/core/permission';

@Component({
  selector: 'app-modal-frecuency',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    DragDropModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggle,
    MatCheckboxModule,
    MatSelectModule,
    MatTooltipModule,
    HasPermissionPipe,
  ],
  templateUrl: './modal-frecuency.component.html',
  styleUrl: './modal-frecuency.component.scss'
})
export class ModalFrecuencyComponent {
  readonly PERMISSIONS = ROUTES_PERMISSIONS.FREQUENCIES;

  private data!: any;

  @Input('data') 
  set _data(value) {
    this.data = value;
    if (this.data) {
      this.getListFrecuencies()
      this.loadWeekDayClientCounts()
    }
  }

  listFrecuencies: FrequenciesAttributes[]= []
  daysList: { code: number; day: string, name: string }[] = [
    {code: 1, day: "LU", name: "Lunes"},
    {code: 2, day: "MA", name: "Martes"},
    {code: 3, day: "MI", name: "Miércoles"},
    {code: 4, day: "JU", name: "Jueves"},
    {code: 5, day: "VI", name: "Viernes"},
    {code: 6, day: "SA", name: "Sábado"},
    {code: 7, day: "DO", name: "Domingo"}
  ];

  expandedElement: FrequenciesAttributes | null;
  tables: { id: string; table: MatTable<any> }[] = [];
  showManyOrder: boolean = false

  @ViewChildren(CdkDropList) cdkDropLists!: QueryList<CdkDropList>;
  @ViewChildren(MatTable) mainTables!: QueryList<MatTable<any>>;
  @ViewChild("table", { static: false }) table: MatTable<any>;

  modeWeekDays: boolean = false
  listDayFrecuencies: { 
    code: number,
    day: string,
    name: string,
    totalClients: number,
    businessPartenerFrequencyList: SubRouteBusinessPartnersAttributes[],
    businessPartenerFrequencyListOriginal: SubRouteBusinessPartnersAttributes[]
  }[] = this.daysList.map(day => ({
    ...day,
    totalClients: 0,
    businessPartenerFrequencyList: [],
    businessPartenerFrequencyListOriginal: []
  }));

  expandedWDElement = null;

  dialogRefMoveBP: MatDialogRef<any>;
  
  actionForMoveBP: string = null;
  originalFrecuencyId = null;
  frecuencyIdForActionSelected = null;
  bpFromFrecuencyToMove: SubRouteBusinessPartnersAttributes[] = [];
  
  actionLabels: Record<string, string> = {
    copy: 'copiado',
    move: 'movido',
    delete: 'eliminado',
  };

  errorLabels: Record<string, string> = {
    copy: 'copiar',
    move: 'mover',
    delete: 'eliminar',
  };

  @ViewChild("moveBPFromFrecuencyModal") moveBPFromFrecuencyModal!: TemplateRef<any>;
  
  constructor(
    private readonly frequencyService: SubRouteFrequenciesService,
    private readonly frequencybpService: SubRouteFrequenciesBPService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private readonly permissionService: PermissionService,
  ){
  }

  ngAfterViewInit(): void {
  }

  getListFrecuencies(){
    this.frequencyService.findBySubRouteId(this.data._id).subscribe({
      next: (res) => {
        const filteredFrequencies = res?.data?.filter((frequency: any) => frequency.type === 'W') || [];
        this.listFrecuencies = filteredFrequencies.map((frequency: any) => ({
          ...frequency,
          businessPartenerFrequencyList: [] as SubRouteBusinessPartnersAttributes[],
          businessPartenerFrequencyListOriginal: [] as SubRouteBusinessPartnersAttributes[]
        }));
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener las frecuencias","Cerrar",{ duration: 5000});
      },
    });
  }

  getFrecuencyName(days: number[]): string {
    const dayNames = days.map((code) => this.daysList.find((day) => day.code === code)?.name).filter(Boolean);
    return dayNames.join('-');
  }

  toggleExpand(element: any) {
    element.expanded = !element.expanded;

    if (this.expandedElement === element) {
      this.expandedElement = null;
      element.businessPartenerFrequencyList = [];
      element.businessPartenerFrequencyListOriginal = [];
    } else {
      this.expandedElement = element;
      this.fetchBusinessbyFrequency(element);
      const mainTable = this.mainTables.toArray().find((table) => {
        const tableId = table["_elementRef"].nativeElement.getAttribute("id");
        return tableId === `table-${element._id}`;
      });
      this.registerTable(element._id, mainTable);
    }

    const expandedElements = this.listFrecuencies.filter((item:any) => item.expanded).length;
    expandedElements > 1 ? this.showManyOrder = true : this.showManyOrder = false
  }

  closeExpand(element: any){
    element.expanded = !element.expanded
    this.expandedElement = null;
  }

  fetchBusinessbyFrequency(expanded: any): void {
    this.frequencybpService.findClientByFrequency(this.data._id,expanded._id.toString()).subscribe({
      next: (res) => {
        expanded.businessPartenerFrequencyList = res.data;
        expanded.businessPartenerFrequencyListOriginal = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener frecuencias.","Cerrar",{ duration: 5000});
      },
    });
  }

  onSearch(event: string, data): void {
    const searchTerm = event.trim().toLowerCase();

    if (searchTerm) {
      // Filtrar la lista basada en el término de búsqueda
      data.businessPartenerFrequencyList = data.businessPartenerFrequencyListOriginal.filter(partner => {
        const nameMatch = partner.name?.toLowerCase().includes(searchTerm);
        const contactMatch = partner.principalContact?.fullName?.toLowerCase().includes(searchTerm) || partner.principalPhone?.phone?.includes(searchTerm);
        return nameMatch || contactMatch;
      });
    } else {
      // Si no hay término de búsqueda, restaurar la lista original
      data.businessPartenerFrequencyList = [...data.businessPartenerFrequencyListOriginal];
    }
  }

  registerTable(elementId: string, table: MatTable<any>) {
    this.tables[elementId] = { id: elementId, table: table };
  }

  drop(event: CdkDragDrop<any[]>, elementId: string) {
    let transferredElement;
    if (event.previousContainer === event.container) {//uno x uno
      moveItemInArray(event.container.data,event.previousIndex,event.currentIndex);
      if (event.container.id.split("-")[1]) {
        this.updateFrequencyPosition(event);
      }
    } else { //entre frecuencias
      let frequencyId = event.container.id.split("-")[1];
      transferredElement = event.previousContainer.data[event.previousIndex];
      const alreadyExists = event.container.data.some(
        (item) => item._id === transferredElement._id
      );

      if (!frequencyId) {
        let frequencyId = event.previousContainer.id.split("-")[1];
        this.deleteFrequencyBusinessPartner(transferredElement, frequencyId);
      } else {
        this.updateFrequencyBusinessPartner(transferredElement, frequencyId);
      }
      
      if (!alreadyExists) {
        transferArrayItem(event.previousContainer.data,event.container.data,event.previousIndex,event.currentIndex);
      }
    }

    const mainTable = this.mainTables.toArray().find((table) => {
      const tableId = table["_elementRef"].nativeElement.getAttribute('id');
      return tableId === `table-${elementId}`;
    });


    if (mainTable) {
      mainTable.renderRows();
    } else {
      const elementId = event.previousContainer.id.split("-")[1]
      this.tables[elementId].table.renderRows();
      this.table.renderRows();
    }
  }

  onListDrop(event: CdkDragDrop<any[]>, element) {
    // Swap the elements around
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    // updates moved data and table, but not dynamic if more dropzones
    element.businessPartenerFrequencyList = cloneDeep(element.businessPartenerFrequencyList);
  }

  private puedeReordenar(): boolean {
    const puede = this.permissionService.has(this.PERMISSIONS.UPDATE);
    if (!puede) {
      this.snackBar.open('No tiene permisos para reordenar frecuencias.', 'Cerrar', { duration: 5000 });
    }
    return puede;
  }

  savePosition(frecuencyId?){
    if (!this.puedeReordenar()) {
      return;
    }
    if(frecuencyId){
      let findOrder:any = this.listFrecuencies.find(frecuency => String(frecuency._id) == frecuencyId)
      if(findOrder && Array.isArray(findOrder.businessPartenerFrequencyList)){
        this.updateFrequencyManyPosition(findOrder.businessPartenerFrequencyList, frecuencyId)
      }
    }else{
      const promises = this.listFrecuencies.map((frequency: any) => {
        if (Array.isArray(frequency.businessPartenerFrequencyList)) {
          return this.updateFrequencyManyPosition(frequency.businessPartenerFrequencyList, frequency._id);
        }
        return Promise.resolve();
      });
  
      Promise.all(promises)
      .then(() => {
      })
      .catch((error) => {
        this.snackBar.open(error.error.message || "Error en alguna de las actualizaciones","Cerrar",{ duration: 5000});
      });
    }
  }

  //UNO POR UNO
  updateFrequencyPosition(result): void {
    let businessPartnerPosition: any = {
      businessPartnerId: result.container.data[result.currentIndex]._id.toString(),
      position: result.currentIndex,
    };
    this.frequencybpService.updatePosition(this.data._id,result.container.id.split("-")[1],businessPartnerPosition)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",});
          this.getListFrecuencies()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
        },
      });
  }

  deleteFrequencyBusinessPartner(result, frequencyId: string): void {
    this.frequencybpService.deleteBusinessPartnerF(this.data._id,frequencyId,result._id.toString(),result)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro eliminado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",});
          this.getListFrecuencies()
          //this.fetchallBusinessPartner();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al eliminar el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
        },
      });
  }


  updateFrequencyBusinessPartner(result, frequencyId: string): void {
    this.frequencybpService.createBusinessPartnerF(this.data,frequencyId,result._id.toString(),result)
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",panelClass: "snack-bar-success",});
          this.getListFrecuencies()
          //this.fetchallBusinessPartner();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
        },
      });
  }

  //VARIOS
  updateFrequencyManyPosition(result, frecuency): void {
    if(result && result.length == 0 ){
      return;
    }

    let orderData = result.map(bp => bp._id)

    this.frequencybpService.updatePositionsBusinessPartnerFrecuency(this.data._id, frecuency, orderData).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",});
        this.showManyOrder = false
        this.getListFrecuencies()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
      },
    });
  }

  onChangeWeekDaysMode(){

  }

  toggleExpandWD(element: any) {
    element.expanded = !element.expanded;

    if (this.expandedWDElement === element) {
      this.expandedWDElement = null;
      element.businessPartenerFrequencyList = [];
      element.businessPartenerFrequencyListOriginal = [];
    } else {
      this.expandedWDElement = element;
      this.fetchBusinessbyWeekDay(element);
      const mainTable = this.mainTables.toArray().find((table) => {
        const tableId = table["_elementRef"].nativeElement.getAttribute("id");
        return tableId === `table-${element._id}`;
      });
      this.registerTable(element._id, mainTable);
    }

    //const expandedElements = this.daysList.filter((item:any) => item.expanded).length;
    //expandedElements > 1 ? this.showManyOrder = true : this.showManyOrder = false
  }

  fetchBusinessbyWeekDay(expanded: any): void {
    this.frequencybpService.findClientByWeekDay(this.data._id,expanded.code).subscribe({
      next: (res) => {
        expanded.businessPartenerFrequencyList = res.data;
        expanded.businessPartenerFrequencyListOriginal = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al frecuencias de socio de negocio.","Cerrar",{ duration: 5000});
      },
    });
  }

  /**
   * Fetches the per weekday client summary so the panel header can show the
   * count without the user having to expand the day.
   */
  loadWeekDayClientCounts(): void {
    if (!this.data?._id) return;
    this.frequencyService.findWeekdayClientsCount(this.data._id).subscribe({
      next: (res) => {
        const counts = res?.data;
        if (!counts) return;
        const codeToKey: Record<number, keyof WeekdayClientsCount> = {
          1: 'monday',
          2: 'tuesday',
          3: 'wednesday',
          4: 'thursday',
          5: 'friday',
          6: 'saturday',
          7: 'sunday',
        };
        this.listDayFrecuencies.forEach((weekDay) => {
          weekDay.totalClients = counts[codeToKey[weekDay.code]] ?? 0;
        });
      },
      error: (err) => {
        this.snackBar.open(err.error?.message || "Error al obtener el conteo de clientes por día.", "Cerrar", { duration: 5000 });
      },
    });
  }

  saveWDPosition(weekDay){
    if (!this.puedeReordenar()) {
      return;
    }
    if(weekDay){
      let findOrder:any = this.listDayFrecuencies.find(dayF => String(dayF.code) == weekDay.code)
      if(findOrder && Array.isArray(findOrder.businessPartenerFrequencyList)){
        this.updateWeekDayManyPosition(findOrder.businessPartenerFrequencyList, weekDay)
      }
    }
  }

  updateWeekDayManyPosition(result, weekDay): void {
    if(result && result.length == 0 ){
      return;
    }

    let orderData = result.map(bp => bp._id)
    
    this.frequencybpService.updatePositionsBusinessPartnerWeekDay(this.data._id, weekDay.code, orderData).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 5000,verticalPosition: "top",});
        this.showManyOrder = false
        this.fetchBusinessbyWeekDay(weekDay);
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 5000, verticalPosition: "top" });
      },
    });
  }

  openMoveBPModal(bpList: any[], action: string, originalFrecuencyId: string) {
    this.actionForMoveBP = action;
    this.bpFromFrecuencyToMove = bpList.filter(p => p.selected);
    this.originalFrecuencyId = originalFrecuencyId;

    if(action != 'delete'){
      this.dialogRefMoveBP = this.dialog
      .open(this.moveBPFromFrecuencyModal, {
        panelClass: "form-modal-move-bp-from-frecuency",
        disableClose: true,
      })
    
    this.dialogRefMoveBP.afterClosed()
      .subscribe((result) => {
        if (result) {
          
        }
      });
    } else {
      this.dialog
        .open(DeleteConfirmationComponent, {
          data: {
            message: `¿Estás seguro de eliminar ${this.bpFromFrecuencyToMove.length > 1 ? 'a los clientes' : 'al cliente'} de la frecuencia?`,
            //name: item,
          },
          panelClass: "delete-modal",
          disableClose:true
        })
        .afterClosed()
        .subscribe((result) => result && this.moveBP());
    }
    
  }

  moveBP(){
    const bpSelected = this.bpFromFrecuencyToMove;

    let dataToMove: ICreateManyBPFrecuency = {
      businessPartnerIds: bpSelected.map(e => e._id.toString())
    }
    if(this.actionForMoveBP == 'copy'){
      this.frequencybpService.createManyBusinessPartnerFromFrecuency(this.data._id.toString(),this.frecuencyIdForActionSelected, dataToMove).subscribe({
        next: () => {
          this.snackBar.open(`Registro ${this.actionLabels[this.actionForMoveBP] || 'actualizado'} con éxito`, "Cerrar", {duration: 5000,verticalPosition: "top",});
          this.getListFrecuencies()
          this.dialogRefMoveBP.close();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || `Error al ${this.errorLabels[this.actionForMoveBP] || 'actualizar'} actualizar registros`,"Cerrar",{ duration: 5000, verticalPosition: "top" });
          this.dialogRefMoveBP.close();
        },
      });
    } else if(this.actionForMoveBP == 'move') {
      const payload: IMoveFrequencyBP = {
        fromFrequencyId: this.originalFrecuencyId,
        toFrequencyId: this.frecuencyIdForActionSelected,
        businessPartnerIds: bpSelected.map(e => e._id.toString()),
      };
      this.frequencybpService.moveManyBusinessPartnerFromFrecuency(this.data._id.toString(),payload).subscribe({
        next: () => {
              this.snackBar.open(`Registro ${this.actionLabels[this.actionForMoveBP] || 'actualizado'} con éxito`, "Cerrar", {duration: 5000,verticalPosition: "top",});
              this.getListFrecuencies()
              this.dialogRefMoveBP.close();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || `Error al ${this.errorLabels[this.actionForMoveBP] || 'actualizar'} actualizar registros`,"Cerrar",{ duration: 5000, verticalPosition: "top" });
          this.dialogRefMoveBP.close();
        },
      });
    } else if(this.actionForMoveBP == 'delete'){
      
      this.frequencybpService.deleteManyBusinessPartnerFromFrecuency(this.data._id.toString(),this.originalFrecuencyId, dataToMove).subscribe({
        next: () => {
          this.snackBar.open(`Registro ${this.actionLabels[this.actionForMoveBP] || 'actualizado'} con éxito`, "Cerrar", {duration: 5000,verticalPosition: "top",});
          this.getListFrecuencies()
          //this.dialogRefMoveBP.close();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || `Error al ${this.errorLabels[this.actionForMoveBP] || 'actualizar'} actualizar registros`,"Cerrar",{ duration: 5000, verticalPosition: "top" });
          //this.dialogRefMoveBP.close();
        },
      });
    }else{
      //this.dialogRefMoveBP.close();
    }
  }
  
  getSelectedCount(ft: any): number {
    return ft.businessPartenerFrequencyList?.filter((bp: any) => bp?.selected)?.length || 0;
  }
  
  openModalFrecuency(): void {
    const data: MapModalInputData = {
      type: MapModalTypeEnum.FRECUENCY_DATE_ROUTE,
      tripId: null,
      element: {
        _id: this.data._id.toString(),
        data: this.listFrecuencies,
        modeWeekDays: true,
      },
      document: MonitorDocumentTypeEnum.NONE,
      groupDocuments: [],
      map: {
        displayMode: 'drawer',
        captions: { title: this.data?.name || 'Frecuencia'}
      }
    }

    this.openMap(data)
  }

  openMap(data) {
    this.dialog.open(MapModalComponent, {
      width: '90%',
      //height: '80%',
      data: data
    });
  }
}
